import { inject, Injectable, signal } from '@angular/core';
import { FileDto, StrictHttpResponse } from '@api-client';
import { BrowserBridgeService } from './browser-bridge.service';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
  private readonly toast = inject(ToastService);
  private readonly browserBridge = inject(BrowserBridgeService);

  downloading = signal(false);

  async downloadFile(file: FileDto) {
    const url = file.url;

    this.downloading.set(true);
    await fetch(url, {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
      },
      mode: 'cors',
      referrerPolicy: 'no-referrer-when-downgrade',
    })
      .then((response) => response.blob()) // 파일을 Blob 형태로 변환
      .then((blob) => {
        this.browserBridge.downloadBlob(blob, file.name);
        this.downloading.set(false);
      })
      .catch((error) => {
        this.toast.error('파일 다운로드 중 오류가 발생했습니다.');
        console.error('파일 다운로드 오류:', error);
        this.downloading.set(false);
      });
  }

  async downLoadFileToServer(res: StrictHttpResponse<Blob>, fileName: string) {
    if (!res) return;
    this.downloading.set(true);
    const filename =
      res.headers.get('Content-Disposition')?.split('filename=')[1] ??
      `${fileName}.zip`;
    const blob = res.body;
    this.browserBridge.downloadBlob(blob, decodeURI(filename));
    this.downloading.set(false);
  }
}
